import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

export const oidcConfig: UserManagerSettings = {
    authority: import.meta.env.VITE_OAUTH_AUTHORITY,
    /* eslint-disable camelcase */
    client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
    redirect_uri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
    response_type: import.meta.env.VITE_OAUTH_RESPONSE_TYPE,
    /* eslint-enable */
    scope: import.meta.env.VITE_OAUTH_SCOPE,
    refreshTokenAllowedScope: "",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
    stateStore: new WebStorageStateStore({ store: globalThis.sessionStorage })
};
